/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.0.0
 */

import get from 'lodash/get';
import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '@/main/reducers/rootReducer';
import { IOptionItemProps } from '@components/common/Select/Select';

import { initialCreateInquiryState } from './createInquiryReducer';
import { ICreateInquiryReducer, IInquiryAttachProps, IInquiryUser, ITopicInfo } from './types/createInquiryTypes';

const makeSelectorInquiryState = (state: IRootReducer): ICreateInquiryReducer => state.createInquiry;

export const makeSelectorInquiryAttachList = (): OutputSelector<IRootReducer, IInquiryAttachProps[],
    (state: ICreateInquiryReducer) => IInquiryAttachProps[]> =>
    createSelector(
        makeSelectorInquiryState,
        (state: ICreateInquiryReducer) => get(state, 'attachList', initialCreateInquiryState.attachList),
    );

export const makeSelectorInquiryIsLoading = (): OutputSelector<IRootReducer, boolean,
    (state: ICreateInquiryReducer) => boolean> =>
    createSelector(
        makeSelectorInquiryState,
        (state: ICreateInquiryReducer) => get(state, 'isLoading', initialCreateInquiryState.isLoading),
    );

export const makeSelectorInquiryTopicInfo = (): OutputSelector<IRootReducer, ITopicInfo,
    (state: ICreateInquiryReducer) => ITopicInfo> =>
    createSelector(
        makeSelectorInquiryState,
        (state: ICreateInquiryReducer) => get(state, 'topicInfo', initialCreateInquiryState.topicInfo),
    );

export const makeSelectorInquiryTopicList = (): OutputSelector<IRootReducer, IOptionItemProps[],
    (state: ICreateInquiryReducer) => IOptionItemProps[]> =>
    createSelector(
        makeSelectorInquiryState,
        (state: ICreateInquiryReducer) => get(state, 'topicList', initialCreateInquiryState.topicList),
    );

export const makeSelectorInquiryUserInfo = (): OutputSelector<IRootReducer, IInquiryUser,
    (state: ICreateInquiryReducer) => IInquiryUser> =>
    createSelector(
        makeSelectorInquiryState,
        (state: ICreateInquiryReducer) => get(state, 'userInfo', initialCreateInquiryState.userInfo),
    );
